import { render, staticRenderFns } from "./lawGubunPop.vue?vue&type=template&id=2c2c599f"
import script from "./lawGubunPop.vue?vue&type=script&lang=js"
export * from "./lawGubunPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c2c599f')) {
      api.createRecord('2c2c599f', component.options)
    } else {
      api.reload('2c2c599f', component.options)
    }
    module.hot.accept("./lawGubunPop.vue?vue&type=template&id=2c2c599f", function () {
      api.rerender('2c2c599f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/law/register/lawGubunPop.vue"
export default component.exports